import { render, staticRenderFns } from "./SidebarComments.vue?vue&type=template&id=3800a1c4&"
import script from "./SidebarComments.vue?vue&type=script&lang=js&"
export * from "./SidebarComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports